import React from 'react'
import { useParams } from 'react-router-dom'
import { InvoiceViewShell } from './InvoiceViewShell'
import { ReadOnlyInvoice } from './ReadOnlyInvoice'

export const InvoiceViewPage = () => {
  const { token } = useParams()

  return (
    <InvoiceViewShell>
      <ReadOnlyInvoice token={token} />
    </InvoiceViewShell>
  )
}
